var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBackGround({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 88,
    viewBox: "0 0 100 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_372_2906",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 88
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H84C92.8366 0 100 7.16344 100 16V88H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_372_2906)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.812 -8.60918L93.5517 -39.7698C93.03 -40.2062 92.3917 -40.4799 91.7159 -40.5569L43.4547 -46.0611C42.7122 -46.1457 41.9622 -45.9888 41.316 -45.6135C40.6698 -45.2382 40.1618 -44.6646 39.8673 -43.9778L19.7015 3.05947C17.0786 9.1775 16.8705 16.5022 19.0826 24.8299C20.7721 31.1902 23.8839 38.1836 28.331 45.616C35.802 58.1015 44.4067 67.485 44.7695 67.8782C45.1011 68.2381 45.5051 68.5238 45.9549 68.7166C46.4047 68.9094 46.8901 69.0051 47.3795 68.9971C47.9142 68.9887 60.6433 68.7515 74.8377 65.5543C83.2871 63.6509 90.4979 61.0829 96.2697 57.9215C103.827 53.7822 108.988 48.5811 111.611 42.4628L131.777 -4.57445C132.071 -5.26125 132.137 -6.02473 131.963 -6.75156C131.789 -7.47839 131.386 -8.12983 130.812 -8.60918Z",
    fill: "#C6B9FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.54 -5.12168L89.933 -31.5545C89.4905 -31.9247 88.949 -32.1568 88.3758 -32.2221L47.437 -36.8912C46.8071 -36.963 46.1709 -36.8299 45.6228 -36.5116C45.0746 -36.1932 44.6437 -35.7067 44.3939 -35.124L27.2878 4.77655C25.0628 9.96632 24.8863 16.1797 26.7628 23.2439C28.1959 28.6391 30.8356 34.5715 34.6079 40.8762C40.9453 51.4674 48.2446 59.4271 48.5523 59.7607C48.8336 60.066 49.1763 60.3083 49.5578 60.4719C49.9394 60.6355 50.3512 60.7166 50.7663 60.7099C51.2198 60.7027 62.0176 60.5015 74.0584 57.7894C81.2259 56.1748 87.3426 53.9964 92.2387 51.3147C98.6491 47.8034 103.027 43.3914 105.252 38.2015L122.359 -1.69911C122.608 -2.28171 122.664 -2.92935 122.516 -3.5459C122.369 -4.16245 122.027 -4.71505 121.54 -5.12168Z",
    fill: "#C6B9FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.162 -1.66181L86.1639 -23.4038C85.7998 -23.7083 85.3545 -23.8992 84.883 -23.9529L51.2093 -27.7934C50.6912 -27.8525 50.168 -27.743 49.7171 -27.4811C49.2662 -27.2193 48.9117 -26.8191 48.7063 -26.3399L34.6358 6.47985C32.8057 10.7486 32.6605 15.8593 34.204 21.6699C35.3828 26.1077 37.554 30.9873 40.6569 36.1731C45.8697 44.8848 51.8736 51.432 52.1267 51.7063C52.3581 51.9574 52.6399 52.1568 52.9538 52.2913C53.2676 52.4259 53.6063 52.4926 53.9478 52.487C54.3208 52.4811 63.2024 52.3156 73.1064 50.0848C79.0019 48.7568 84.0331 46.965 88.0603 44.7592C93.3331 41.871 96.9345 38.242 98.7646 33.9731L112.835 1.15337C113.041 0.67416 113.086 0.141451 112.965 -0.365684C112.844 -0.872818 112.562 -1.32735 112.162 -1.66181Z",
    fill: "#C6B9FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.062 1.70736L82.5886 -15.4143C82.3019 -15.6541 81.9512 -15.8045 81.5799 -15.8468L55.0621 -18.8711C54.6541 -18.9176 54.242 -18.8314 53.887 -18.6252C53.5319 -18.419 53.2528 -18.1038 53.091 -17.7264L42.0106 8.11886C40.5694 11.4805 40.4551 15.5052 41.6705 20.081C42.5988 23.5757 44.3087 27.4183 46.7522 31.5021C50.8572 38.3625 55.5852 43.5184 55.7845 43.7344C55.9668 43.9322 56.1887 44.0892 56.4359 44.1951C56.683 44.3011 56.9498 44.3536 57.2186 44.3492C57.5124 44.3446 64.5066 44.2143 72.3059 42.4575C76.9486 41.4117 80.9106 40.0007 84.0821 38.2636C88.2344 35.9892 91.0704 33.1314 92.5116 29.7696L103.592 3.9243C103.754 3.54693 103.79 3.12742 103.694 2.72806C103.599 2.32869 103.377 1.97075 103.062 1.70736Z",
    fill: "#C6B9FF",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2236 9.04203C71.1382 8.71037 73.8519 10.3417 75.3648 13.9361C76.2451 17.5079 75.1627 20.3157 72.1177 22.3597C68.2429 24.1478 65.0272 23.3478 62.4707 19.9597C60.5468 16.1588 61.2213 12.9118 64.4942 10.2185C65.3544 9.68686 66.2642 9.29471 67.2236 9.04203Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8 24.9478C66.7566 24.9034 70.7096 24.9505 74.6588 25.089C76.5394 25.5262 77.9825 26.5615 78.9882 28.1949C77.298 29.9669 75.2587 31.1905 72.8706 31.8655C67.8921 33.2523 63.3432 32.4052 59.2235 29.3243C58.7704 28.9809 58.3625 28.5888 58 28.1478C59.151 26.3996 60.751 25.3329 62.8 24.9478Z",
    fill: "#FEFEFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBackGround);
export default __webpack_public_path__ + "static/media/UserBackGround.edcf9043332a1ff15aac690b10bbcb61.svg";
export { ForwardRef as ReactComponent };